import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchObservationQuestionTypes = async () => {
	const url = "/observations/admin/questiontypes/";

	const response = await cmsClient.get<IAdminQuestionType[]>(url);
	return response.data;
};

const useObservationQuestionTypes = () => {
	const query = useQuery(
		["observation-question-types"],
		fetchObservationQuestionTypes
	);

	return query;
};

export default useObservationQuestionTypes;
